import MaskedInput from "react-text-mask";
import RutTextMask from "rut-text-mask";
import { isRutValid } from "../../../../../utils";

const PersonalDataForm = ({ 
    activeBtn, 
    name, 
    personalData,
    localRut,
    invalidEmail, 
    invalidPhoneNumber,
    invalidFirstName,
    invalidLastName,
    invalidCompanyName,
    handleNameChange, 
    handlePersonalDataInputChange,
    handleRutBlur
}) => {
    return (
        <div className="modal-box__contact-form__top">
            <div className="form-element">
                <input
                    className={"input" + (invalidFirstName ? " error" : "")}
                    type="text"
                    placeholder={activeBtn === "company" ? "Nombre de contacto" : "Nombre"}
                    value={name.first_name}
                    name="first_name"
                    onChange={(e) => handleNameChange(e)}
                />
                <span className="error">
                    {name.first_name.trim().length > 0 && invalidFirstName 
                        ? "El campo debe contener al menos 2 letras." 
                        : ""}
                </span>
            </div>
            {activeBtn === "company" ? (
                <div className="form-element">
                    <input
                        className={"input" + (invalidCompanyName ? " error" : "")}
                        type="text"
                        placeholder="Razón Social"
                        value={personalData.company_name}
                        name="company_name"
                        onChange={(e) => handlePersonalDataInputChange(e)}
                    />
                    <span className="error">
                        {personalData.company_name && personalData.company_name.trim().length > 0 && invalidCompanyName 
                            ? "El campo debe contener al menos 2 letras." 
                            : ""}
                    </span>
                </div>
            ) : (
                <div className="form-element">
                    <input
                        className={"input" + (invalidLastName ? " error" : "")}
                        type="text"
                        placeholder="Apellido"
                        value={name.last_name}
                        name="last_name"
                        onChange={(e) => handleNameChange(e)}
                    />
                    <span className="error">
                        {name.last_name.trim().length > 0 && invalidLastName 
                            ? "El campo debe contener al menos 2 letras." 
                            : ""}
                    </span>
                </div>
            )}
            <div className="form-element">
                <MaskedInput
                    mask={RutTextMask}
                    name="rut"
                    placeholder={
                        activeBtn === "company"
                            ? "Ingresa RUT de tu empresa"
                            : "Ingresa tu RUT"
                    }
                    value={localRut}
                    data-skip-imask="true"
                    guide={false}
                    keepCharPositions={false}
                    autoComplete="off"
                    className={
                        localRut.length >= 8 &&
                        !isRutValid(localRut)
                            ? "error"
                            : null
                    }
                    onChange={(e) => handlePersonalDataInputChange(e)}
                    onBlur={handleRutBlur}
                />
                <span className="error">{localRut.length >= 8 && !isRutValid(localRut) ? "RUT inválido" : ""}</span>
            </div>
            <div className="form-element">
                <input
                    className={"input" + (invalidPhoneNumber ? " error" : "")}
                    type="text"
                    placeholder="Ingresa tu Teléfono"
                    value={personalData.phone_number}
                    name="phone_number"
                    onChange={(e) => handlePersonalDataInputChange(e)}
                />
                <span className="error">{personalData.phone_number.length >= 8 && invalidPhoneNumber ? "Teléfono inválido" : ""}</span>
            </div>
            <div className="form-element">
                <input
                    className={"input" + (invalidEmail ? " error" : "")}
                    type="text"
                    placeholder="Ingresa tu Email"
                    value={personalData.email}
                    name="email"
                    onChange={(e) => handlePersonalDataInputChange(e)}
                    required
                />
                <span className="error">{personalData.email.length > 0 && invalidEmail ? "Email inválido" : ""}</span>
            </div>
        </div>
    );
};

export default PersonalDataForm;